import { render, staticRenderFns } from "./NavigationPreviewBtn.vue?vue&type=template&id=2f0a1495&scoped=true"
import script from "./NavigationPreviewBtn.vue?vue&type=script&lang=js"
export * from "./NavigationPreviewBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0a1495",
  null
  
)

export default component.exports